module.exports = __webpack_public_path__ + "static/media/typescript.3aeee229.svg";